import Enums from "@/plugins/Enums"
import moment from "moment";

export default {
	computed: {
		
	},
	methods:{
		getDc1Type(type){
			switch (type) {
				case Enums.OryxTypes.Caracter:
				case Enums.OryxTypes.Memo:
					return "text"
				case Enums.OryxTypes.Datetime:
				case Enums.OryxTypes.Date:
					return "datetime"
				case Enums.OryxTypes.Number:
				case Enums.OryxTypes.Logical:
					return "number"
				default:
					return "text"
			}
		},
		getDefaultValueByDc1Type(type){
			switch (type) {
				case Enums.OryxTypes.Caracter:
				case Enums.OryxTypes.Memo:
					return ""
				case Enums.OryxTypes.Datetime:
				case Enums.OryxTypes.Date:
					return ""
				case Enums.OryxTypes.Number:
				case Enums.OryxTypes.Logical:
					return 0
				default:
					return ""
			}
		},
		exportPiecesSale(prefix, fileName, items ){
			let text = ""

			for (const item of items.filter(item => !!item[prefix+"peca"])) {
				if(prefix == "vdv"){
					for (let index = 0; index < (!!item.vd3qtde ? item.vd3qtde : item.vdvqtde); index++) {
						text += `${item[prefix+"peca"]}\n`
					}
				}else{
					text += `${item[prefix+"peca"]}\n`
				}
			}
			if(prefix == "vdv"){
				for (const item of items.filter(item => !item[prefix+"peca"])) {
					for (let index = 0; index < (!!item.vd3qtde ? item.vd3qtde : item.vdvqtde); index++) {
						text += `${(!!item.vd2produto ? item.vd2produto : item.vdvproduto)}\n`
					}
				}
			}

			if(!text)
				return
			var element = document.createElement('a');
			element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
			element.setAttribute('download', `pecas_${fileName}.txt`);

			element.style.display = 'none';
			document.body.appendChild(element);

			element.click();

			document.body.removeChild(element);
		},
		enableShortKeys(){
			document.onkeydown = (e) => {
				if (e.key == "F1") {
					this.$router.push("/oryxpdv/cliente")
					e.preventDefault()
				} else if (e.key == "F2") {
				this.$router.push("/oryxpdv/venda")
				e.preventDefault()
				} else if (e.key == "F3") {
					this.$router.push("/oryxpdv/devolucoes")
				e.preventDefault()
				} else if (e.key == "F4") {
					this.$router.push("/oryxpdv/pedidos-consignados")
				e.preventDefault()
				} else if (e.key == "F5") {
				this.$router.push("/oryxpdv/pedidos")
				e.preventDefault()
				} else if (e.key == "F6") {
				this.parameters.openProductSearch = true
				e.preventDefault()
				} else if (e.key == "Alt" && this.$route.name == 'sale'){
					this.$store.dispatch("vd1/nextTabBody")
					e.preventDefault()
				} else if (e.key == "F7") {
					this.parameters.openDialogFiscalPaf = true
					e.preventDefault()
				}
			}
		},
		disableShortKeys(){
			document.onkeydown = (e) => {
			}
		},
		async saveVd1(isTefTransaction = false, docfis = "", params = null){

			const lxd = params ? params.lxd : this.lxd
			const vd1 = params ? params.vd1 : this.vd1
			const vdk = params ? params.vdk : this.vdk
			const isEANHasConsignment = params ? params.isEANHasConsignment : this.isEANHasConsignment
			const vd1model = params ? params.vd1model : this.vd1model
			const lstDc1 = params ? params.lstDc1 : this.lstDc1
			const store = params ? params.store : this.$store
			const insert = params ? params.insert : this.insert

			let getDc1edicao = this.getDc1edicao;
			let enableEdit = this.enableEdit;
			let getRules = this.getRules;

			if(isTefTransaction){

				let pendingTransactionOnNonBilledOrder = await store.dispatch("lxi/findPendingTransactionOnNonBilledOrder"
				, vd1.vd1.vd1pedido
				, {root: true})

				if(pendingTransactionOnNonBilledOrder){
					if(!pendingTransactionOnNonBilledOrder.lxipedido){
						store.dispatch("parameters/openDialog", {
							titleText: "Erro",
							titleColor: "red",
							text: `Transação pendente ${pendingTransactionOnNonBilledOrder.lxitransac} sem pedido associado.`
						}, {root: true})
						return
					}

					store.dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: `Existem transações pendentes do pedido ${pendingTransactionOnNonBilledOrder.lxipedido}. Rejeite ou confirme a transação antes de prosseguir.`
					}, {root: true})
					return
				}
			}

			if(params){
				getDc1edicao = (field) => {
					if (lstDc1 == null)
						return Enums.Dc1EdicaoType.Normal
					return lstDc1.filter(dc1 => dc1.dc1campo.toLowerCase() == field)[0]?.dc1edicao
				}
				enableEdit = (field) => {
					switch (getDc1edicao(field)) {
						case Enums.Dc1EdicaoType.Normal:
							return true
						case Enums.Dc1EdicaoType.Insert:
							return insert
						case Enums.Dc1EdicaoType.NotEditable:
							return false
						default:
							return false;
					}        
				}
				getRules = (field, formattersRules = [], disabled = false) => {
					if (enableEdit(field) == false)
						return []
					
					if (lstDc1 == null)
					return formattersRules
				
					let dc1nulo = lstDc1.filter(dc1 => dc1.dc1campo.toLowerCase() == field)[0]?.dc1nulo
					let dc1espaco = lstDc1.filter(dc1 => dc1.dc1campo.toLowerCase() == field)[0]?.dc1espaco
		
					let value
		
					let rules = [ val => {
						if (disabled) {
							return true
						}
						switch (typeof(val)) {
							case "boolean":
								return true
							case "number":
								if ((!val && dc1nulo) || !!val) {
									return true
								}
								break
							default:
								if (dc1nulo && (val == "" || val == null || val == undefined)){
									return true
								}
		
								value = (val == null || val == undefined) ? "" : val
		
								if (typeof(value) == "object") {
									value = value.toString()
								}
		
								if(value && value.trim().length > 0)
									return true
								if (dc1espaco && value.length > 0 && value.trim()  == "")
									return true
									
								break;
						}
					
						return "Campo obrigatório"
					}]
		
					rules = rules.concat(formattersRules)
					return rules
				}
			}


			if (lxd.lxdmultrom) {
				for (const vd7 of vd1.lstVd7) {
					if (vd7.items.length == 0) {
						store.dispatch("parameters/openDialog", {
							titleText: "Erro",
							titleColor: "red",
							text: `Carrinho ${vd7.vd7volume} sem nenhum item informado`
						}, {root: true})
						return
					}
				}

				if (vd1.lstVd7.length > 1 && isEANHasConsignment) {
					store.dispatch("parameters/openDialog", {
							titleText: "Erro",
							titleColor: "red",
							text: `Não é possível devolver peças em consignação quando existir múltiplos romaneios.<br/>Remova os itens em consignação devolvidos na aba cliente.`
						}, {root: true})
						return
				}
				
				if(vd1.lstVd7.length > 1 && isTefTransaction){
					let count = 0
					for (const cart of vd1.lstVd7) {
						count += cart.items.length
					}
					if(count > 0){
						store.dispatch("parameters/openDialog", {
							titleText: "Erro",
							titleColor: "red",
							text: `Não é possível utilizar múltiplos carrinhos com a opção de pagamento TEF integrada.<br/>Mantenha os itens em apenas um carrinho.`
						}, {root: true})
						return
					}
				}
			}

			const validateOrder = () => {
				const fieldOnResume = [
					"vd1pronta",
					"vd1observa",
					"vd1vend",
					"vd1tipo"
				]

				for (const key of Object.keys(vd1model)) {
					if ((key == "vd1opercom" || key == "vd1pedido") && vd1.insert){
						continue;
					}
	
					let rules = getRules(key.toLowerCase(), [], !enableEdit(key.toLowerCase()))
					for (const rule of rules) {
						let success = rule(vd1model[key])
						if (success && success != true) {

							if(fieldOnResume.includes(key) && !vd1.showResume){
								vd1.showResume = true
							}

							let dc1 = lstDc1.filter(dc1 => dc1.dc1campo.toLowerCase() == key)[0]
							store.dispatch("parameters/showSnackBar", {
								show: true,
								timeout: 5000,
								text: "Campo " + dc1.dc1nome + " obrigatório.",
								color: "red"
							}, {root: true})
							return false
						}
					}
				}
				return true
			}

			if (validateOrder(getDc1edicao)){
				vd1.docfis = docfis
				if (vd1model.toIssueFiscalDocument || isTefTransaction) {
					const payload = await store.dispatch("vd1/save", isTefTransaction, {root: true})
					return payload
				}
				await store.dispatch("vd1/validateTransmit", isTefTransaction, {root: true})
				.then(async (payload) =>{
					if (payload) {
						await store.dispatch("vd1/checkPrintVolumeLabel", isTefTransaction, {root: true})
					}
				})
				return true
			}
		},
		async clearVd1(){
			this.$store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Preparando uma nova venda...", indeterminate: true }, {root: true})
			let id = this.vd1model.id
			let vd1pedido = this.vd1model.vd1pedido
			this.$store.dispatch("vd1/clearCart")
			this.$store.dispatch("vdk/clear")
			this.$store.dispatch("vd1/init", {
				"id": id,
				"vd1usuario": this.dc4.dc4usuario,
				"vd1pedido": vd1pedido,
				"dc4nome": this.dc4.dc4nome,
				"vd1abert": moment(new Date()).format("YYYY-MM-DDTHH:mm:ssZ"),
				"vd1entrada": moment(new Date()).format("YYYY-MM-DDTHH:mm:ssZ"),
				"vd1entrega": moment(new Date()).format("YYYY-MM-DDTHH:mm:ssZ"),
				"vd1cliente": this.lxd.lxdcliente,
				"vd1lista": this.lxd.lxdlista,
				"vd1conpgto": this.lxd.lxdconpgto,
				"vd1emissor": this.lx0.lx0cliente,
			})
			
			if (this.lxd.lxdlista) {
				await this.$store.dispatch("cv6/get", this.lxd.lxdlista)
				.then(cv6 => this.$store.dispatch("vd1/selectVd1Lista", {cv6}))
			}

			if (this.lxd.lxdconpgto) {
				this.vd1.lastFormCv8 = Enums.PaymFormCV8.CONPGTO
				this.$store.dispatch("vd1/calculateCv8", {})
			}

			this.$store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},

		async validatePassFromChosenUser(value, dc0arquivo, permission, loggedUser) {
			return await new Promise(resolve => {
				this.$store.dispatch("parameters/openManagerDialog", {
					dc0arquivo: dc0arquivo,
					permission: permission,
					loggedUser: loggedUser,
					selectedUser: value,
					confirmAction: () => resolve(true), 
					cancelAction: () => resolve(false),
				})
			}) 
		},
		async validateChosenUser(value, field, dc0arquivo, permission, loggedUser) {
			let fieldRef = ""
			if(field) {
				fieldRef = `r${field}`
				setTimeout(() => {
					this.$refs[fieldRef].model = ""
					this.$refs[fieldRef].searchField("")
				});
				if(value) {
					let validated = await this.validatePassFromChosenUser(value, dc0arquivo, permission, loggedUser)
					if(!validated) {
						setTimeout(() => {
							this.$refs[fieldRef].model = ""
							this.$refs[fieldRef].searchField("")
						});
					} else {
						this.$refs[fieldRef].model = value
					}
				}
			}
		},
	}
}